<template>
  <div class="card-wrapper" @click="onCardClick">
    <Card style="width: 17rem; overflow: hidden" class="custom-card">
      <template #title>
        <!-- 动态显示类别名称 -->
        <div class="card-title">{{ categoryName }}</div>
      </template>
      <template #subtitle>
        <div class="card-subtitle">{{ latestTaskTitle }}</div>
      </template>
      <div class="card-title-container"></div>
      <template #content>
        <div class="level-text">Level 1 - Beginner</div>
        <div class="hours-text">10 HR</div>
      </template>
      <template #footer>
        <div class="progress-container">
          <div
            class="remaining-progress"
            :style="{ width: remainingProgressWidth }"
          ></div>
          <div class="progress-bar" :style="{ width: progressWidth }"></div>
        </div>
        <div class="progress-text">{{ progress }}/10000</div>
      </template>
    </Card>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import { computed } from "vue";
import { useStore } from "vuex";
import Card from "primevue/card";

const progress = 10; // 这里设定了40，您可以根据需要进行调整
const progressWidth = computed(() => `${progress}%`);
const remainingProgressWidth = computed(() => `${100 - progress}%`); // 剩余的进度

const props = defineProps({
  categoryName: String,
  categoryId: String,
  latestTaskTitle: String,
});

console.log(props.categoryName, props.categoryId, props.latestTaskTitle); // 打印当前点击的卡片的 categoryId 和 categoryName 以及 latestTaskTitle
const emit = defineEmits(["edit-category"]);

function onCardClick() {
  console.log(props.categoryName, props.categoryId, props.latestTaskTitle); // 打印当前点击的卡片的 categoryId 和 categoryName 以及 latestTaskTitle

  // 发出带有 categoryId 的 edit-category 事件
  emit("edit-category", {
    categoryId: props.categoryId,
    categoryName: props.categoryName,
  });
}
const store = useStore();

const latestTaskTitle = computed(() => {
  const title = store.getters.latestTaskTitles[props.categoryName];
  return title || "Latest Task";
});
</script>

<style scoped>
.custom-card {
  padding: 10px;
  height: 110px;
  background-color: #000;
  border-radius: 10px;
  color: #ffffff;
  background-image: url("@/assets/beginstart.svg");
  background-position: right -40px top -90px;
  background-repeat: no-repeat;
}

.card-wrapper {
  padding: 10px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 8px 0 rgba(224, 222, 222, 0.2);
  width: 18.45rem;
  height: 12rem;
  position: relative; /* 用于定位子元素 */
}
.level-text,
.hours-text {
  position: absolute;
}
.level-text {
  left: 10px; /* 距离左边的距离 */
  color: #000;
  font-size: 0.85rem; /* 字体大小 */
  bottom: 41px; /* 距离底部的距离 */
  font-weight: 500;
}
.hours-text {
  right: 10px; /* 距离右边的距离 */
  color: #000;
  font-size: 1.5rem; /* 字体大小 */
  bottom: 34px; /* 距离底部的距离 */
}

.progress-bar {
  height: 7px;
  background-color: #702dff; /* 或者选择一个更明显的颜色 */
  border-radius: 5px;
  left: 10px;
  bottom: 27px;
  position: absolute;
}

.remaining-progress {
  height: 7px;
  background-color: #d6d6d6; /* 灰色，表示剩余的进度 */
  border-radius: 5px;
  position: absolute;
  right: 10px;
  bottom: 27px;
}
.progress-text {
  position: absolute;
  left: 10px;
  bottom: 6px;
  color: GRAY;
  font-size: 0.7rem;
}
</style>
